import { GET, POST, PUT, DELETE } from "../../../api";

export const findAll = async (currentPage, perPage, search,searchDateFrom,searchDateTo) => {
  return await GET(
    `/admin/customer-management/customer?page=${currentPage || 1}&per_page=${
      perPage || 10
    }&name=${search || ""}&from=${
      searchDateFrom || ""
      }&to=${
        searchDateTo || ""
      }`
  );
};

export const findOne = async (id) => {
  return await GET(`/admin/customer-management/customer/${id}`);
};

export const Status = async (id) => {
  return await POST(`/admin/customer-management/customer/${id}`);
};

export const Delete = async (id) => {
  return await DELETE(`/admin/customer-management/customer/${id}`);
};

